// src/stores/option.ts
import { defineStore } from "pinia";
import { ref } from "vue";

export const useOptionStore = defineStore("optionStore", () => {
  // Track pending option type for creation/selection
  const pendingOptionTypeId = ref<number | null>(null);

  function setPendingOptionTypeId(typeId: number): void {
    pendingOptionTypeId.value = typeId;
  }

  function consumePendingOptionTypeId(): number | null {
    const typeId = pendingOptionTypeId.value;
    pendingOptionTypeId.value = null;
    return typeId;
  }

  return {
    pendingOptionTypeId,
    setPendingOptionTypeId,
    consumePendingOptionTypeId
  };
});
